import React, { useMemo, useState } from 'react';
import {
  Badge,
  Button,
  Card,
  Container,
  Divider,
  Grid,
  Group,
  Paper,
  Radio,
  ScrollArea,
  Select,
  SimpleGrid,
  Stack,
  Table,
  Text,
  Textarea,
  ThemeIcon,
  Title,
} from '@mantine/core';
import {
  IconArrowLeft,
  IconBuildingFactory2,
  IconCheck,
  IconChecklist,
  IconChevronRight,
  IconCircleCheck,
  IconClockHour4,
  IconCoins,
  IconFileDescription,
  IconFilter,
  IconGitCompare,
  IconInfoCircle,
  IconRosetteDiscountCheck,
  IconScale,
  IconSearch,
  IconShieldCheck,
  IconTruckDelivery,
  IconX,
} from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

const comparisonRequestsSeed = [
  {
    id: 'PR-2026-0105',
    title: 'Yeni personel için çalışma ekipmanı talebi',
    department: 'Bilgi İşlem',
    requester: 'Muhammed Selvi',
    approvedAt: '2026-03-18 11:30',
    needByDate: '2026-03-25',
    priority: 'HIGH',
    totalEstimated: 44300,
    quoteCount: 3,
    currentStatus: 'QUOTES_COLLECTED',
    selectedQuoteId: null,
    lines: [
      { id: 'PRL-1', lineNo: 1, description: 'Dell Latitude 15 Laptop', quantity: 1, uom: 'Adet' },
      { id: 'PRL-2', lineNo: 2, description: 'Laptop Çantası', quantity: 1, uom: 'Adet' },
      { id: 'PRL-3', lineNo: 3, description: 'Kablosuz Mouse', quantity: 1, uom: 'Adet' },
    ],
    quotes: [
      {
        id: 'Q-2026-0040',
        vendorName: 'Tekno Tedarik A.Ş.',
        totalAmount: 100200,
        currency: 'TRY',
        validUntil: '2026-03-22',
        leadTimeDays: 5,
        paymentTerms: 'Peşin',
        status: 'SUBMITTED',
        score: 72,
        summary: 'Fiyat yüksek ancak ürün bulunabilirliği iyi.',
        lines: [
          { requisitionLineId: 'PRL-1', description: 'Dell Latitude 15 Laptop', quantity: 1, uom: 'Adet', unitPrice: 86000, lineAmount: 86000 },
          { requisitionLineId: 'PRL-2', description: 'Laptop Çantası', quantity: 1, uom: 'Adet', unitPrice: 3600, lineAmount: 3600 },
          { requisitionLineId: 'PRL-3', description: 'Kablosuz Mouse', quantity: 1, uom: 'Adet', unitPrice: 600, lineAmount: 600 },
          { requisitionLineId: null, description: 'Kurulum ve teslimat', quantity: 1, uom: 'Hizmet', unitPrice: 10000, lineAmount: 10000 },
        ],
      },
      {
        id: 'Q-2026-0041',
        vendorName: 'OfisDonanım Ltd.',
        totalAmount: 98500,
        currency: 'TRY',
        validUntil: '2026-03-24',
        leadTimeDays: 4,
        paymentTerms: '15 gün vade',
        status: 'SUBMITTED',
        score: 91,
        summary: 'Fiyat/termin dengesi iyi, ödeme koşulu avantajlı.',
        lines: [
          { requisitionLineId: 'PRL-1', description: 'Dell Latitude 15 Laptop', quantity: 1, uom: 'Adet', unitPrice: 84000, lineAmount: 84000 },
          { requisitionLineId: 'PRL-2', description: 'Laptop Çantası', quantity: 1, uom: 'Adet', unitPrice: 3500, lineAmount: 3500 },
          { requisitionLineId: 'PRL-3', description: 'Kablosuz Mouse', quantity: 1, uom: 'Adet', unitPrice: 1100, lineAmount: 1100 },
          { requisitionLineId: null, description: 'Kurulum ve teslimat', quantity: 1, uom: 'Hizmet', unitPrice: 9900, lineAmount: 9900 },
        ],
      },
      {
        id: 'Q-2026-0042',
        vendorName: 'Kurumsal Market',
        totalAmount: 103750,
        currency: 'TRY',
        validUntil: '2026-03-21',
        leadTimeDays: 2,
        paymentTerms: '7 gün vade',
        status: 'SUBMITTED',
        score: 79,
        summary: 'Termin iyi ancak toplam maliyet yüksek.',
        lines: [
          { requisitionLineId: 'PRL-1', description: 'Dell Latitude 15 Laptop', quantity: 1, uom: 'Adet', unitPrice: 89000, lineAmount: 89000 },
          { requisitionLineId: 'PRL-2', description: 'Laptop Çantası', quantity: 1, uom: 'Adet', unitPrice: 3900, lineAmount: 3900 },
          { requisitionLineId: 'PRL-3', description: 'Kablosuz Mouse', quantity: 1, uom: 'Adet', unitPrice: 850, lineAmount: 850 },
          { requisitionLineId: null, description: 'Kurulum ve teslimat', quantity: 1, uom: 'Hizmet', unitPrice: 10000, lineAmount: 10000 },
        ],
      },
    ],
  },
  {
    id: 'PR-2026-0108',
    title: 'Aylık kırtasiye ve sarf malzeme alımı',
    department: 'İdari İşler',
    requester: 'Ayşe Kaya',
    approvedAt: '2026-03-18 09:10',
    needByDate: '2026-03-23',
    priority: 'MEDIUM',
    totalEstimated: 12650,
    quoteCount: 2,
    currentStatus: 'QUOTE_SELECTED',
    selectedQuoteId: 'Q-2026-0050',
    lines: [
      { id: 'PRL-4', lineNo: 1, description: 'A4 Fotokopi Kağıdı', quantity: 20, uom: 'Koli' },
      { id: 'PRL-5', lineNo: 2, description: 'Tükenmez Kalem', quantity: 50, uom: 'Adet' },
    ],
    quotes: [
      {
        id: 'Q-2026-0050',
        vendorName: 'OfisDonanım Ltd.',
        totalAmount: 12480,
        currency: 'TRY',
        validUntil: '2026-03-24',
        leadTimeDays: 2,
        paymentTerms: '30 gün vade',
        status: 'SELECTED',
        score: 94,
        summary: 'Mevcut anlaşmalı tedarikçi, en uygun toplam maliyet.',
        lines: [
          { requisitionLineId: 'PRL-4', description: 'A4 Fotokopi Kağıdı', quantity: 20, uom: 'Koli', unitPrice: 440, lineAmount: 8800 },
          { requisitionLineId: 'PRL-5', description: 'Tükenmez Kalem', quantity: 50, uom: 'Adet', unitPrice: 18, lineAmount: 900 },
          { requisitionLineId: null, description: 'Diğer ofis sarf kalemleri', quantity: 1, uom: 'Paket', unitPrice: 2780, lineAmount: 2780 },
        ],
      },
      {
        id: 'Q-2026-0051',
        vendorName: 'Kurumsal Market',
        totalAmount: 13020,
        currency: 'TRY',
        validUntil: '2026-03-22',
        leadTimeDays: 1,
        paymentTerms: 'Peşin',
        status: 'REJECTED',
        score: 81,
        summary: 'Termin iyi fakat ödeme koşulu zayıf.',
        lines: [
          { requisitionLineId: 'PRL-4', description: 'A4 Fotokopi Kağıdı', quantity: 20, uom: 'Koli', unitPrice: 455, lineAmount: 9100 },
          { requisitionLineId: 'PRL-5', description: 'Tükenmez Kalem', quantity: 50, uom: 'Adet', unitPrice: 18.4, lineAmount: 920 },
          { requisitionLineId: null, description: 'Diğer ofis sarf kalemleri', quantity: 1, uom: 'Paket', unitPrice: 3000, lineAmount: 3000 },
        ],
      },
    ],
  },
];

const currencyFormatter = new Intl.NumberFormat('tr-TR', {
  style: 'currency',
  currency: 'TRY',
  maximumFractionDigits: 2,
});

const priorityConfig = {
  LOW: { label: 'Düşük', color: 'gray' },
  MEDIUM: { label: 'Orta', color: 'blue' },
  HIGH: { label: 'Yüksek', color: 'orange' },
  CRITICAL: { label: 'Kritik', color: 'red' },
};

const statusConfig = {
  QUOTES_COLLECTED: { label: 'Teklifler Toplandı', color: 'blue' },
  QUOTE_SELECTED: { label: 'Teklif Seçildi', color: 'teal' },
  SUBMITTED: { label: 'Kaydedildi', color: 'blue' },
  SELECTED: { label: 'Seçildi', color: 'green' },
  REJECTED: { label: 'Reddedildi', color: 'red' },
};

function StatusBadge({ status }) {
  const cfg = statusConfig[status] || { label: status, color: 'gray' };
  return (
    <Badge variant="light" color={cfg.color} radius="sm">
      {cfg.label}
    </Badge>
  );
}

function SummaryCard({ title, value, subtitle, color, icon: Icon }) {
  return (
    <Card withBorder radius="lg" p="lg" shadow="sm">
      <Group justify="space-between" align="flex-start">
        <Stack gap={4}>
          <Text size="sm" c="dimmed" fw={500}>{title}</Text>
          <Text fw={800} size="1.55rem" lh={1.1}>{value}</Text>
          <Text size="xs" c="dimmed">{subtitle}</Text>
        </Stack>
        <ThemeIcon color={color} variant="light" size={46} radius="md">
          <Icon size={22} />
        </ThemeIcon>
      </Group>
    </Card>
  );
}

function SectionCard({ title, description, children, action }) {
  return (
    <Paper withBorder radius="lg" p="lg" shadow="sm">
      <Group justify="space-between" align="flex-start" mb="md">
        <div>
          <Title order={4}>{title}</Title>
          {description ? <Text size="sm" c="dimmed" mt={4}>{description}</Text> : null}
        </div>
        {action}
      </Group>
      {children}
    </Paper>
  );
}

function InfoRow({ label, value }) {
  return (
    <>
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Text size="sm" c="dimmed">{label}</Text>
        {typeof value === 'string' || typeof value === 'number' ? (
          <Text size="sm" fw={600} ta="right">{value || '-'}</Text>
        ) : value}
      </Group>
      <Divider />
    </>
  );
}

export default function ProcurementQuoteSelectionPage() {
  const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState('ALL');
  const [selectedRequestId, setSelectedRequestId] = useState(comparisonRequestsSeed[0]?.id || '');
  const [selectedQuoteId, setSelectedQuoteId] = useState(comparisonRequestsSeed[0]?.quotes?.[1]?.id || '');
  const [selectionReason, setSelectionReason] = useState(
    'Toplam maliyet, vade avantajı ve uygun termin birlikte değerlendirildiğinde en dengeli teklif seçilmiştir.'
  );

  const filteredRequests = useMemo(() => {
    return comparisonRequestsSeed.filter((item) =>
      statusFilter === 'ALL' ? true : item.currentStatus === statusFilter
    );
  }, [statusFilter]);

  const selectedRequest = useMemo(() => {
    return comparisonRequestsSeed.find((item) => item.id === selectedRequestId) || comparisonRequestsSeed[0] || null;
  }, [selectedRequestId]);

  const selectedQuote = useMemo(() => {
    return selectedRequest?.quotes?.find((q) => q.id === selectedQuoteId) || selectedRequest?.quotes?.[0] || null;
  }, [selectedRequest, selectedQuoteId]);

  const stats = useMemo(() => {
    return {
      totalRequests: comparisonRequestsSeed.length,
      readyToSelect: comparisonRequestsSeed.filter((item) => item.currentStatus === 'QUOTES_COLLECTED').length,
      selected: comparisonRequestsSeed.filter((item) => item.currentStatus === 'QUOTE_SELECTED').length,
      totalQuotes: comparisonRequestsSeed.reduce((acc, item) => acc + item.quoteCount, 0),
    };
  }, []);

  const comparisonRows = useMemo(() => {
    if (!selectedRequest) return [];

    return selectedRequest.lines.map((reqLine) => {
      const row = {
        id: reqLine.id,
        lineNo: reqLine.lineNo,
        description: reqLine.description,
        quantity: `${reqLine.quantity} ${reqLine.uom}`,
      };

      selectedRequest.quotes.forEach((quote) => {
        const match = quote.lines.find((line) => line.requisitionLineId === reqLine.id);
        row[quote.id] = match ? currencyFormatter.format(match.lineAmount) : '-';
      });

      return row;
    });
  }, [selectedRequest]);

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <Paper
          withBorder
          radius="xl"
          p="xl"
          shadow="sm"
          style={{
            background: 'linear-gradient(135deg, rgba(245,247,250,1) 0%, rgba(255,255,255,1) 100%)',
          }}
        >
          <Group justify="space-between" align="flex-start" gap="xl">
            <Stack gap="sm" maw={860}>
              <Group gap="sm">
                <Button variant="subtle" leftSection={<IconArrowLeft size={16} />} px={0} onClick={() => navigate("/purchase-dashboard")}>
                  Geri Dön
                </Button>
                <Badge variant="light" color="violet" leftSection={<IconGitCompare size={14} />}>
                  Statik demo teklif seçim ekranı
                </Badge>
              </Group>
              <div>
                <Title order={1}>Teklif Değerlendirme / Teklif Seçimi</Title>
                <Text size="sm" c="dimmed" mt="sm">
                  Toplanan tekliflerin fiyat, termin, ödeme koşulu ve genel uygunluk açısından kıyaslandığı seçim ekranı.
                  Bu adımdan sonra seçilen teklif mal kabul ve fatura akışına temel oluşturur.
                </Text>
              </div>
            </Stack>
          </Group>

          <SimpleGrid cols={{ base: 1, sm: 2, xl: 4 }} spacing="md" mt="xl">
            <SummaryCard title="Talep Havuzu" value={stats.totalRequests} subtitle="Teklif kıyasına açık talepler" color="blue" icon={IconFileDescription} />
            <SummaryCard title="Seçim Bekleyen" value={stats.readyToSelect} subtitle="Karar bekleyen dosyalar" color="orange" icon={IconClockHour4} />
            <SummaryCard title="Seçilmiş Teklif" value={stats.selected} subtitle="Kararı verilmiş talepler" color="teal" icon={IconRosetteDiscountCheck} />
            <SummaryCard title="Toplanan Teklif" value={stats.totalQuotes} subtitle="Tedarikçi teklif adedi" color="grape" icon={IconBuildingFactory2} />
          </SimpleGrid>
        </Paper>

        <Grid gutter="lg">
          <Grid.Col span={{ base: 12, xl: 3.5 }}>
            <Stack gap="md">
              <SectionCard title="Talep Filtresi" description="Karar verilecek talebi seçin.">
                <Select
                  value={statusFilter}
                  onChange={(value) => setStatusFilter(value || 'ALL')}
                  data={[
                    { value: 'ALL', label: 'Tüm Talepler' },
                    { value: 'QUOTES_COLLECTED', label: 'Teklifler Toplandı' },
                    { value: 'QUOTE_SELECTED', label: 'Teklif Seçildi' },
                  ]}
                  leftSection={<IconFilter size={16} />}
                />
              </SectionCard>

              <SectionCard title="Karar Kuyruğu" description="Talep bazında teklif dosyaları.">
                <Stack gap="xs">
                  {filteredRequests.map((item) => (
                    <Paper
                      key={item.id}
                      withBorder
                      radius="md"
                      p="sm"
                      onClick={() => {
                        setSelectedRequestId(item.id);
                        setSelectedQuoteId(item.selectedQuoteId || item.quotes?.[0]?.id || '');
                      }}
                      style={{
                        cursor: 'pointer',
                        borderColor: selectedRequestId === item.id ? 'var(--mantine-color-violet-4)' : undefined,
                        backgroundColor: selectedRequestId === item.id ? 'var(--mantine-color-violet-0)' : undefined,
                      }}
                    >
                      <Group justify="space-between" align="flex-start" wrap="nowrap">
                        <div>
                          <Text fw={700} size="sm">{item.id}</Text>
                          <Text size="sm" mt={2}>{item.title}</Text>
                          <Text size="xs" c="dimmed" mt={4}>{item.department} • {item.quoteCount} teklif</Text>
                        </div>
                        <Stack gap={6} align="flex-end">
                          <StatusBadge status={item.currentStatus} />
                          <Badge variant="light" color={priorityConfig[item.priority]?.color || 'gray'}>
                            {priorityConfig[item.priority]?.label || item.priority}
                          </Badge>
                        </Stack>
                      </Group>
                    </Paper>
                  ))}
                </Stack>
              </SectionCard>

              <SectionCard title="Süreç Akışı" description="Bu ekranın süreçteki konumu.">
                <Stack gap="sm">
                  <Paper withBorder radius="md" p="sm">
                    <Group wrap="nowrap" align="flex-start">
                      <ThemeIcon color="blue" variant="light" mt={2}><IconChecklist size={16} /></ThemeIcon>
                      <div>
                        <Text size="sm" fw={700}>1. Talep Onaylandı</Text>
                        <Text size="xs" c="dimmed" mt={2}>Talep onay sürecini tamamladı.</Text>
                      </div>
                    </Group>
                  </Paper>
                  <Paper withBorder radius="md" p="sm">
                    <Group wrap="nowrap" align="flex-start">
                      <ThemeIcon color="orange" variant="light" mt={2}><IconBuildingFactory2 size={16} /></ThemeIcon>
                      <div>
                        <Text size="sm" fw={700}>2. Teklifler Toplandı</Text>
                        <Text size="xs" c="dimmed" mt={2}>Tedarikçilerden fiyat ve koşullar sisteme girildi.</Text>
                      </div>
                    </Group>
                  </Paper>
                  <Paper withBorder radius="md" p="sm">
                    <Group wrap="nowrap" align="flex-start">
                      <ThemeIcon color="teal" variant="light" mt={2}><IconCircleCheck size={16} /></ThemeIcon>
                      <div>
                        <Text size="sm" fw={700}>3. Teklif Seçimi</Text>
                        <Text size="xs" c="dimmed" mt={2}>Bu sayfada uygun teklif seçilir ve karar kaydı oluşur.</Text>
                      </div>
                    </Group>
                  </Paper>
                </Stack>
              </SectionCard>
            </Stack>
          </Grid.Col>

          <Grid.Col span={{ base: 12, xl: 8.5 }}>
            <Stack gap="lg">
              {selectedRequest && (
                <>
                  <SimpleGrid cols={{ base: 1, xl: 2 }} spacing="md">
                    <SectionCard title="Talep Özeti" description="Kıyaslanan tekliflerin bağlı olduğu onaylı talep.">
                      <Stack gap="sm">
                        <InfoRow label="Talep No" value={selectedRequest.id} />
                        <InfoRow label="Başlık" value={selectedRequest.title} />
                        <InfoRow label="Departman" value={selectedRequest.department} />
                        <InfoRow label="Talep Eden" value={selectedRequest.requester} />
                        <InfoRow label="Onay Tarihi" value={selectedRequest.approvedAt} />
                        <InfoRow label="İhtiyaç Tarihi" value={selectedRequest.needByDate} />
                        <InfoRow label="Tahmini Tutar" value={currencyFormatter.format(selectedRequest.totalEstimated)} />
                        <InfoRow label="Toplanan Teklif" value={selectedRequest.quoteCount} />
                        <InfoRow label="Mevcut Durum" value={<StatusBadge status={selectedRequest.currentStatus} />} />
                      </Stack>
                    </SectionCard>

                    <SectionCard title="Seçim Kararı" description="Karar verilecek teklif ve gerekçe alanı.">
                      <Stack gap="md">
                        <Radio.Group value={selectedQuoteId} onChange={setSelectedQuoteId} label="Seçilecek Teklif">
                          <Stack mt="sm" gap="xs">
                            {selectedRequest.quotes.map((quote) => (
                              <Paper key={quote.id} withBorder radius="md" p="sm">
                                <Group justify="space-between" align="center">
                                  <Radio value={quote.id} label={`${quote.vendorName} • ${quote.id}`} />
                                  <Group gap="xs">
                                    <Text fw={700}>{currencyFormatter.format(quote.totalAmount)}</Text>
                                    <StatusBadge status={quote.status} />
                                  </Group>
                                </Group>
                              </Paper>
                            ))}
                          </Stack>
                        </Radio.Group>

                        <Textarea
                          label="Seçim Gerekçesi"
                          minRows={5}
                          value={selectionReason}
                          onChange={(event) => setSelectionReason(event.currentTarget.value)}
                        />

                        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="sm">
                          <Button color="teal" leftSection={<IconCheck size={16} />}>Teklifi Seç</Button>
                          <Button variant="light" color="red" leftSection={<IconX size={16} />}>Kararı İptal Et</Button>
                        </SimpleGrid>
                      </Stack>
                    </SectionCard>
                  </SimpleGrid>

                  <SectionCard title="Teklif Kıyas Tablosu" description="Talep satırlarının teklif bazlı karşılaştırmalı görünümü.">
                    <ScrollArea>
                      <Table striped highlightOnHover verticalSpacing="sm" horizontalSpacing="md">
                        <Table.Thead>
                          <Table.Tr>
                            <Table.Th>#</Table.Th>
                            <Table.Th>Talep Kalemi</Table.Th>
                            <Table.Th>Miktar</Table.Th>
                            {selectedRequest.quotes.map((quote) => (
                              <Table.Th key={quote.id}>{quote.vendorName}</Table.Th>
                            ))}
                          </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                          {comparisonRows.map((row) => (
                            <Table.Tr key={row.id}>
                              <Table.Td>{row.lineNo}</Table.Td>
                              <Table.Td>{row.description}</Table.Td>
                              <Table.Td>{row.quantity}</Table.Td>
                              {selectedRequest.quotes.map((quote) => (
                                <Table.Td key={`${row.id}-${quote.id}`}>
                                  <Text fw={600}>{row[quote.id]}</Text>
                                </Table.Td>
                              ))}
                            </Table.Tr>
                          ))}
                        </Table.Tbody>
                      </Table>
                    </ScrollArea>
                  </SectionCard>

                  <SimpleGrid cols={{ base: 1, xl: 2 }} spacing="md">
                    <SectionCard title="Teklif Kartları" description="Toplanan tekliflerin üst seviye kıyas görünümü.">
                      <Stack gap="sm">
                        {selectedRequest.quotes.map((quote) => {
                          const isSelected = selectedQuoteId === quote.id;
                          return (
                            <Paper
                              key={quote.id}
                              withBorder
                              radius="md"
                              p="sm"
                              style={{
                                borderColor: isSelected ? 'var(--mantine-color-teal-4)' : undefined,
                                backgroundColor: isSelected ? 'var(--mantine-color-teal-0)' : undefined,
                              }}
                            >
                              <Group justify="space-between" align="flex-start" wrap="nowrap">
                                <div>
                                  <Text fw={700} size="sm">{quote.vendorName}</Text>
                                  <Text size="xs" c="dimmed" mt={4}>{quote.id} • Geçerlilik: {quote.validUntil}</Text>
                                  <Text size="sm" mt={6}>{quote.summary}</Text>
                                </div>
                                <Stack gap={6} align="flex-end">
                                  <Text fw={800}>{currencyFormatter.format(quote.totalAmount)}</Text>
                                  <Badge variant="light" color="violet">Skor: {quote.score}</Badge>
                                  <StatusBadge status={quote.status} />
                                </Stack>
                              </Group>
                              <Divider my="sm" />
                              <SimpleGrid cols={3} spacing="sm">
                                <Paper radius="md" p="xs" bg="gray.0">
                                  <Text size="xs" c="dimmed">Termin</Text>
                                  <Text fw={700} size="sm">{quote.leadTimeDays} gün</Text>
                                </Paper>
                                <Paper radius="md" p="xs" bg="gray.0">
                                  <Text size="xs" c="dimmed">Ödeme</Text>
                                  <Text fw={700} size="sm">{quote.paymentTerms}</Text>
                                </Paper>
                                <Paper radius="md" p="xs" bg="gray.0">
                                  <Text size="xs" c="dimmed">Toplam</Text>
                                  <Text fw={700} size="sm">{currencyFormatter.format(quote.totalAmount)}</Text>
                                </Paper>
                              </SimpleGrid>
                            </Paper>
                          );
                        })}
                      </Stack>
                    </SectionCard>

                    <SectionCard title="Seçilen Teklif Ön İzleme" description="Karar verilecek teklifin detay özeti.">
                      {selectedQuote ? (
                        <Stack gap="sm">
                          <InfoRow label="Teklif No" value={selectedQuote.id} />
                          <InfoRow label="Tedarikçi" value={selectedQuote.vendorName} />
                          <InfoRow label="Toplam" value={currencyFormatter.format(selectedQuote.totalAmount)} />
                          <InfoRow label="Termin" value={`${selectedQuote.leadTimeDays} gün`} />
                          <InfoRow label="Ödeme Koşulu" value={selectedQuote.paymentTerms} />
                          <InfoRow label="Geçerlilik" value={selectedQuote.validUntil} />
                          <InfoRow label="Durum" value={<StatusBadge status={selectedQuote.status} />} />
                          <InfoRow label="Skor" value={<Badge variant="light" color="violet">{selectedQuote.score}</Badge>} />
                        </Stack>
                      ) : (
                        <Text size="sm" c="dimmed">Teklif seçilmedi.</Text>
                      )}
                    </SectionCard>
                  </SimpleGrid>

                  <SimpleGrid cols={{ base: 1, xl: 3 }} spacing="md">
                    <SummaryCard title="En Düşük Teklif" value={currencyFormatter.format(Math.min(...selectedRequest.quotes.map((q) => q.totalAmount)))} subtitle="Toplam maliyet bazlı en düşük değer" color="red" icon={IconCoins} />
                    <SummaryCard title="En İyi Termin" value={`${Math.min(...selectedRequest.quotes.map((q) => q.leadTimeDays))} gün`} subtitle="Teslim süresi bazlı en hızlı teklif" color="blue" icon={IconTruckDelivery} />
                    <SummaryCard title="Seçim Hazırlığı" value={selectedQuote ? selectedQuote.vendorName : '-'} subtitle="Karar adayı teklif" color="teal" icon={IconScale} />
                  </SimpleGrid>

                  <SectionCard
                    title="Aksiyonlar"
                    description="Seçim sonrası akış için demo butonlar."
                    action={<Button variant="default" leftSection={<IconSearch size={16} />}>Karşılaştırmayı Yazdır</Button>}
                  >
                    <SimpleGrid cols={{ base: 1, md: 3 }} spacing="sm">
                      <Button color="teal" leftSection={<IconCircleCheck size={16} />}>Teklifi Onayla</Button>
                      <Button variant="light" color="orange" leftSection={<IconChevronRight size={16} />}>Mal Kabule Geç</Button>
                      <Button variant="light" color="gray" leftSection={<IconShieldCheck size={16} />}>Karar Kaydı Oluştur</Button>
                    </SimpleGrid>
                  </SectionCard>
                </>
              )}
            </Stack>
          </Grid.Col>
        </Grid>

        <Paper withBorder radius="lg" p="md" shadow="sm" style={{ borderStyle: 'dashed' }}>
          <Group align="flex-start" wrap="nowrap">
            <ThemeIcon color="blue" variant="light" mt={2}><IconInfoCircle size={16} /></ThemeIcon>
            <Text size="sm" c="dimmed">
              Sonraki ekran için en doğru adım “Mal Kabul / Teslim Alma Ekranı”. Çünkü teklif seçimi tamamlandıktan sonra artık fiziksel teslimat,
              eksik / hasarlı ürün kontrolü ve iade süreçleri devreye giriyor.
            </Text>
          </Group>
        </Paper>
      </Stack>
    </Container>
  );
}
